/**
 * Created by Kieran on 06/05/2017.
 */

import axios from 'axios'
import config from '../../config'


import wrapper from 'axios-cache-plugin';

let postCache = wrapper(axios, {
  maxCacheSize: Infinity,
  ttl: 60000,
});

postCache.__addFilter(/user/);

/**
 *
 * @type {{getUser: (()=>AxiosPromise)}}
 */
let UserApi = {

  /**
   *
   * @returns {AxiosPromise}
   */
  authCheck() {
    return axios.get(config.apiUrl + 'user/authCheck');
  },
  getUser() {
    return axios({method: 'get', url: config.apiUrl + 'user/web/'})
  },
  getUserConditions() {
    return axios.get(config.apiUrl + 'user/conditions/');
  },
  getUserGoals() {
    return axios.get(config.apiUrl + 'user/goals/');
  },
  getUserPersonalization() {
    return axios({method: 'get', url: config.apiUrl + 'user/personalization/'})
  },
  getFavouriteFoods() {
    return axios.get(config.apiUrl + 'user/favouriteFoods/')
  },
  putFavouriteFoods(model) {
    return axios.put(config.apiUrl + 'user/favouriteFoods/', model)
  },
  getDislikedFoods() {
    return axios.get(config.apiUrl + 'user/dislikedFoods/')
  },
  putDislikedFoods(model) {
    return axios.put(config.apiUrl + 'user/dislikedFoods/', model)
  },
  paidStatus() {
    return axios.get(config.apiUrl + 'user/paid/status');
  },
  onBoardingStatus() {
    return axios.get(config.apiUrl + 'onboarding/status/')
  },
  getLoginTrackings() {
    return axios.get(config.apiUrl + 'user/login-trackings');
  }
}

export default UserApi





// WEBPACK FOOTER //
// ./src/api/User/index.js